import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useBooking } from "../../context/BookingContext";
import { Link } from "react-router-dom";
import moment from "moment";
import "./MyReservations.css";

const MyReservations = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const { fetchOwnerReservations } = useBooking();
  const [reservations, setReservations] = useState([]);

  useEffect(() => {
    const fetchReservations = async () => {
      if (user?.userID) {
        try {
          const ownerReservations = await fetchOwnerReservations();
          setReservations(ownerReservations.reverse());
          console.log("RESWERV:", ownerReservations);
        } catch (error) {
          console.error("Error fetching reservations:", error);
          setReservations([]);
        }
      }
    };
    fetchReservations();
  }, [fetchOwnerReservations, user?.userID]);

  if (authLoading) return <div className="loading-state">Loading...</div>;

  if (!user)
    return (
      <div className="loading-state">
        Please log in or sign up to view reservations
      </div>
    );

  return (
    <div className="my-reservations-container">
      <h1>My Reservations</h1>
      {!reservations || reservations.length === 0 ? (
        <div className="no-data">No reservations found</div>
      ) : (
        <div className="reservations-grid">
          {reservations.map((reservation) => (
            <div key={reservation.BookingID} className="reservation-card">
              <div className="card-header">
                <h3>
                  <Link to={`/kitchen/${reservation.KitchenID}`}>
                    {reservation.KitchenTitle}
                  </Link>
                </h3>
                <span
                  className={`status-badge status-${reservation.Status?.toLowerCase()}`}
                >
                  {reservation.Status}
                </span>
              </div>

              <div className="card-content">
                <div className="time-section">
                  <div className="time-item">
                    <span className="label">Check-in</span>
                    <span className="value">
                      {moment
                        .utc(reservation.CheckinTimestamp)
                        .local()
                        .format("MMM DD, YYYY HH:mm")}
                    </span>
                  </div>
                  <div className="time-item">
                    <span className="label">Check-out</span>
                    <span className="value">
                      {moment
                        .utc(reservation.CheckoutTimestamp)
                        .local()
                        .format("MMM DD, YYYY HH:mm")}
                    </span>
                  </div>
                </div>

                <div className="details-section">
                  <div className="detail-item">
                    <span className="label">Duration</span>
                    <span className="value">
                      {reservation.BookingType === "hour"
                        ? `${reservation.TotalHours} hr${
                            reservation.TotalHours > 1 ? "s" : ""
                          }`
                        : `${reservation.TotalDays || 1} day${
                            (reservation.TotalDays || 1) > 1 ? "s" : ""
                          }`}
                    </span>
                  </div>
                </div>

                <div className="price-section">
                  <div className="price-item">
                    <span className="label">Base</span>
                    <span className="value">
                      ${reservation.BaseAmount?.toFixed(2)}
                    </span>
                  </div>
                  <div className="price-item">
                    <span className="label">Fees</span>
                    <span className="value">
                      ${reservation.ServiceFee?.toFixed(2)}
                    </span>
                  </div>
                  {reservation.SecurityDeposit > 0 && (
                    <div className="price-item">
                      <span className="label">Deposit</span>
                      <span className="value">
                        ${reservation.SecurityDeposit.toFixed(2)}
                      </span>
                    </div>
                  )}
                  <div className="price-item total">
                    <span className="label">Total</span>
                    <span className="value">
                      ${reservation.TotalAmount?.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyReservations;
